/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.before-and-after-slider' ).length ) {
        $( '.before-and-after-slider' ).each( function( index, element ) {
          const baSlider = new Splide( element, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            gap: '1rem',
            pagination: false,
            speed: 800,
          } );
          baSlider.on( 'overflow', function( isOverflow ) {
            baSlider.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );
          baSlider.mount();
        } );

        const liveRegion = $( '.ba-slider__live-region' );

        $( '.ba-slider__toggle' ).on( 'toggleAfter', ( event ) => {
          const target = $( event.target );
          if ( target.attr( 'aria-pressed' ) ) {
            target.attr( 'aria-pressed', false );
            liveRegion.text( 'Sensitive images are visible' );
          } else {
            liveRegion.text( 'Sensitive images are blurred' );
            target.attr( 'aria-press', true );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
